
import { createClient } from '@supabase/supabase-js'
import type { Database } from './types'

const supabaseUrl = "https://umnghjvicfhrxyasyycs.supabase.co"
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVtbmdoanZpY2Zocnh5YXN5eWNzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAyMjg1OTUsImV4cCI6MjA1NTgwNDU5NX0.hwvTNk1O81YcNU2IpnjbnQUXLwRoQfKdgpfgA6-S0jY"

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
})
